module.exports = __webpack_public_path__ + "media/app/images/youtube-8c08cc56a3eb1145719435a25beb069e.png";